module.exports = __webpack_public_path__ + "img/maas-heng.84c77396.png";